import React, { useState, useEffect } from "react";
import Jitsi from "react-jitsi";
import { Spinner } from "reactstrap";

const JitsiLoader = () => <Spinner className="jitsi-loader" />;

export function JitsiModule(props) {
  const [apiLoaded, setApiLoaded] = useState(false);
  const { settings, clientName, channel, eventCode } = props;
  const { meetingName, password } = settings;

  useEffect(() => {
    importJitisApi();
  }, []);
  const setOnCallEndListener = (JitsiMeetAPI) => {
    JitsiMeetAPI.executeCommand("subject", " ");
  }
  const importJitisApi = () => {
    if (!window.JitsiMeetExternalAPI) {
      const head = document.getElementsByTagName("head")[0];
      const script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("src", "https://meet.jit.si/external_api.js");

      head.addEventListener(
        "load",
        (event) => {
          if (event.target.nodeName === "SCRIPT") {
            setApiLoaded(true);
          }
        },
        true
      );
      head.appendChild(script);
    }
  };
  if (!apiLoaded) return null;
  let rName = meetingName + eventCode + (channel ? channel : "");
  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
      className="jitsi-wrapper"
    >
      <Jitsi
        containerStyle={{ width: "100%", height: "100%" }}
        roomName={rName}
        displayName={clientName}
        password={password}
        loadingComponent={JitsiLoader}
        onAPILoad={(JitsiMeetAPI) => setOnCallEndListener(JitsiMeetAPI)}
        config={{ languageDetection: true }}
        domain={"meet.jirango.com"}
      />
    </div>
  );
}
